/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import * as consts from '../../../const';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from 'tc-client-common';

class ParticipantArchiveExportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [
        { id: 'check-archive1', value: consts.SIGNED_CONSENTINGS, isChecked: true },
        { id: 'check-archive2', value: consts.CONSENT_JOURNAL, isChecked: true },
        { id: 'check-archive3', value: consts.NOTES, isChecked: true }
      ]
    };
    this.initiateExport = this.initiateExport.bind(this);
  }

  initiateExport() {
    const study = this.props.study;
    const username = this.props.user.username;
    this.props.initiateArchiveExport({
      study,
      username
    });
  }

  handleCheckElement(event) {
    let items = this.state.items;
    items.forEach((item) => {
      if (item.value === event.target.value) {
        item.isChecked = event.target.checked;
      }
    });
    const itemChecked = items.find((item) => item.isChecked === true);
    this.setState({ items: items, disabled: !itemChecked });
  }

  render() {
    return (
      <div>
        <div id="reports-modal">
          <div id="reports-modal-body">
            <ul className="checkboxes-list">
              {this.state.items.map((item) => {
                return (
                  <li>
                    <input key={item.id} type="checkbox" checked={item.isChecked} value={item.value} readOnly />{' '}
                    {item.value}
                  </li>
                );
              })}
            </ul>
          </div>
          <div id="reports-modal-footer">
            <hr className="reports-modal-divider" />
            <Button
              id="close-raports-popup"
              theme="default large-button"
              handleClick={this.props.close}
              label={consts.CLOSE}
            />
            <Button
              id="export-raports-popup"
              theme="active large-button"
              handleClick={this.initiateExport}
              label={consts.EXPORT}
            />
          </div>
        </div>
      </div>
    );
  }
}

ParticipantArchiveExportModal.propTypes = {
  close: PropTypes.func
};

export default ParticipantArchiveExportModal;
